import { Injectable } from '@angular/core';
import { UiNormalizer } from 'app/services/utils/ui-normalizer';
import { SquareDeviceLocation } from '../store/square-device-location.models';

@Injectable({
    providedIn: 'root',
})
export class AdapterService {
    adaptAll(items: any[]): SquareDeviceLocation[] {
        return items.map((item) => this.adaptSingle(item));
    }

    adaptSingle(data: {
        location: any;
        square_devices: any[];
    }): SquareDeviceLocation {
        const location = data.location;
        const devices = data.square_devices;

        if (!location) {
            throw new Error('Invalid data: location is required');
        }

        if (!devices) {
            throw new Error('Invalid data: square_devices is required');
        }

        // Map the location and its devices to the SquareDeviceLocation interface
        const newItem = {
            ...location,
            id: location.id,
            locationType: location.location_type,
            children: devices.map((device: any) => ({
                deviceLocationId: device.square_device_location_id,
                ...device.square_device,
            })),
        };

        const { location_type, ...rest } = newItem;

        return UiNormalizer.one(rest);
    }
}
